import React, { useState } from "react";
import SiderUser from "../../components/siderbarcomponentsUser";
import Logo from "../../assets/images/logo.png";
import { FaLock, FaCcMastercard, FaAddressCard } from "react-icons/fa";
import { IoLogoGooglePlaystore } from "react-icons/io5";

const MetodoPago = () => {
  const [plan, setPlan] = useState("mensual");

  return (
    <div className="flex h-screen">
      <SiderUser />

      <div className="flex justify-center items-center h-screen bg-gray-50 py-4 px-10 w-full gap-56">
        <div className="w-[36%] py-6 h-[90%] ">
          <div className=" w-full h-full my-auto">
            <h2 className="text-[22px] font-semibold text-textSubtitle mb-8">
              Metodo de pago
            </h2>
            <p className="mb-4 text-[14px] text-textSubtitle">
              Disfruta tu servicio sin compromisos y con total flexibilidad.
            </p>

            <div className="mb-4 mt-4">
              <label className="mb-4 text-[12px] text-textSubtitle font-medium">
                Facturado A:
              </label>
              <h2 className="border border-gray-300 py-4 px-2 rounded-md text-[14px] text-textTipic mb-8 mt-1">
                Andres Montoya Muñoz
              </h2>
            </div>

            <div className="flex gap-4 mb-8">
              <div className="flex items-center justify-center bg-blue-50 rounded-md border-2 border-bgPrimary w-full py-8">
                <FaAddressCard className="mr-6" color="#2563EB" />
                <button className="text-textPrimary font-medium">
                  Tarjeta de crédito
                </button>
              </div>
              <div className="flex items-center justify-center rounded-md border border-gray-300 w-full py-8">
                <IoLogoGooglePlaystore
                  size={20}
                  className="mr-6"
                  color="gray-100"
                />
                <button className="">Google Pay</button>
              </div>
            </div>

            <div className="relative mb-8">
              <input
                className="w-full p-3 border border-gray-300 rounded-md text-textSubtitle placeholder-textSubtitle"
                placeholder="6508 8234 3354 7832"
              />
              <FaCcMastercard className="absolute right-3 top-3 text-xl text-gray-400" />
            </div>

            <div className="flex gap-4 mb-8">
              <input
                className="w-full p-3 border border-gray-300 rounded-md text-textSubtitle placeholder-textSubtitle"
                placeholder="21/04"
              />
              <input
                className="w-full p-3 border border-gray-300 rounded-md text-textSubtitle placeholder-textSubtitle"
                placeholder="786"
              />
            </div>

            <select className="w-full p-3 border border-gray-300 rounded-md text-textSubtitle mb-8">
              <option>Colombia</option>
              <option>México</option>
              <option>Perú</option>
            </select>

            <input
              className="w-full p-3 border border-gray-300 rounded-md text-textSubtitle placeholder-textSubtitle mb-12"
              placeholder="Andres Montoya"
            />

            <div className="flex gap-4">
              <button className="w-full p-2 border border-gray-300 rounded-md">
                Cancelar Suscripción
              </button>
              <button className="w-full p-2 rounded-md bg-blue-600 text-white">
                Cambiar Tarjeta
              </button>
            </div>
            <p className="text-gray-400 text-[12px] mt-6">
              Al proporcionarnos la información de su tarjeta, nos permite
              cargar a su tarjeta pagos futuros de acuerdo con sus términos.
            </p>
          </div>
        </div>

        <div className="w-[36%] bg-[#EDF2F5] px-12 rounded-2xl shadow-md h-[90%] ">
          <h3 className="text-[22px] font-semibold text-textSubtitle mb-8 mt-6">
            Nuestros planes
          </h3>

          <div
            className={`flex items-center justify-start rounded-md border-2 w-full py-4 px-8 mb-6 ${
              plan === "mensual"
                ? "bg-blue-50 border-bgPrimary"
                : "bg-white border-gray-300"
            }`}
          >
            <input
              type="radio"
              name="plan"
              value="mensual"
              checked={plan === "mensual"}
              onChange={() => setPlan("mensual")}
              className="mr-8 scale-150"
            />
            <div>
              <h2 className="text-textSubtitle font-semibold mb-2">
                Pago Mensual (Actual)
              </h2>
              <p className="text-textTipic font-medium">
                $49.900 / Mes / Vehículo
              </p>
            </div>
          </div>

          <div
            className={`flex items-center justify-between rounded-md border-2 w-full py-4 px-8 mb-8 ${
              plan === "anual"
                ? "bg-blue-50 border-bgPrimary"
                : "bg-white border-gray-300"
            }`}
          >
            <div className="flex items-center">
              <input
                type="radio"
                name="plan"
                value="anual"
                checked={plan === "anual"}
                onChange={() => setPlan("anual")}
                className="mr-8 scale-150"
              />
              <div>
                <h2 className="text-textSubtitle font-semibold mb-2">
                  Pago Anual
                </h2>
                <p className="text-textTipic font-medium">
                  $508.980 / Año / Vehículo
                </p>
              </div>
            </div>

            <div
              className={`flex items-center justify-center px-4 py-2 border rounded-md ${
                plan === "anual"
                  ? "border-bgPrimary text-textPrimary font-semibold"
                  : "bg-gray-100 border-gray-300"
              }`}
            >
              <h2
                className={`text-[12px] ${
                  plan === "anual"
                    ? " text-textPrimary font-semibold"
                    : " text-textSubtitle"
                }`}
              >
                Ahorras 15%
              </h2>
            </div>
          </div>

          <hr className="border-t-2 border-gray-300 mb-6"></hr>

          <div className="flex items-center justify-between text-lg font-bold mb-6">
            <h2 className="text-[20px] text-textSubtitle"> Total:</h2>
            <h2 className="text-[20px] text-textSubtitle"> $69.900 / Mes</h2>
          </div>

          <div className="flex items-center mb-8">
            <FaLock size={20} className="mr-4" />
            <p className="text-gray-600 text-sm">
              Garantizamos que es seguro y protegido, asegurando que todas las
              transacciones están protegidas con el más alto nivel de seguridad.
            </p>
          </div>

          <img className="h-[30%] mx-auto mb-8" src={Logo}></img>

          <button
            className={`w-full p-2 rounded-md cursor-not-allowed ${
              plan === "anual"
                ? " bg-bgPrimary text-white"
                : " bg-gray-300 text-gray-600 "
            }`}
            disabled
          >
            ACTUALIZAR PLAN
          </button>
        </div>
      </div>
    </div>
  );
};

export default MetodoPago;
